import * as React from "react";
import styles from './About.module.scss';

export default function About() {
  return (
    <section className={styles.aboutSection}>
      <div className={styles.contentWrapper}>
        <div className={styles.headerContainer}>
          <div className={styles.aboutTitle}>About</div>
          <div className={styles.brandName}>TRoak</div>
          <div className={styles.tagline}>
            Interactive stories by the best writers
          </div>
        </div>
        <div className={styles.contentSection}>
          <div className={styles.imageContainer}>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/98c079dfdd0209e1898daba5efaf80bf079380e25c1b103e5e974452c3b67c7b?placeholderIfAbsent=true&apiKey=a517fac07ef946f8ab57e1424b0111c7"
              className={styles.featureImage}
              alt="TRoak interactive storytelling platform interface"
            />
            <div className={styles.descriptionContainer}>
              <div className={styles.description}>
                Troak is the ultimate destination for interactive
                storytelling. With millions of immersive stories across every
                genre—mystery, romance, fantasy, and more—Troak offers a
                storytelling experience like no other. Everything is
                AI-generated, from the characters to animations and visuals,
                delivering exceptional quality and unlimited possibilities.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}